const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  description: {
    required: true,
    maxLength: 255
  },
  subject: {
    required: true,
    maxLength: 255
  }
};
export { validations };
